import React, { useEffect, useState } from 'react';
import { contractsService } from './contractsService';
import { PageHeader, DataTable, StatusBadge, LoadingState, ErrorState, StatusType } from '../../components/common';
import { ContractSummaryResponse } from '../../types/api';

export const ContractManagement: React.FC = () => {
  const [contracts, setContracts] = useState<ContractSummaryResponse['contracts']>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const data = await contractsService.getContracts();
        setContracts(data);
      } catch (err: any) {
        setError(err.message || 'Failed to fetch contracts');
      } finally {
        setLoading(false);
      }
    };
    fetchContracts();
  }, []);

  const columns = [
    { header: 'CONTRACT ID', accessor: 'id' as const },
    { header: 'TYPE', accessor: 'type' as const },
    { 
      header: 'STATUS', 
      accessor: 'status' as const,
      render: (value: string) => <StatusBadge status={value as StatusType} />
    },
    { 
      header: 'VALUE', 
      accessor: 'value' as const,
      render: (value: number) => `₹${value.toLocaleString()}`
    },
    { 
      header: 'EXPIRY', 
      accessor: 'expiry' as const,
      render: (value: string) => new Date(value).toLocaleDateString()
    },
  ];

  if (loading) return <LoadingState />;
  if (error || !contracts) return <ErrorState message={error || "Failed to load contracts."} />;

  return (
    <div>
      <PageHeader 
        title="Active Enterprise Contracts" 
        subtitle="Manage and monitor all active service level agreements."
      />
      
      <DataTable 
        columns={columns} 
        data={contracts} 
        emptyMessage="No contracts found."
      />
    </div>
  );
};
